/* =============================================================================
   Static display data for Names · The Perfect Register.
   The Task 3 layout fixture was removed in Task 4: the register grid is live
   (`process=names-register`). What remains is genuinely static content: the
   engine's alphabet (display copy), the approved hero set, and country labels.
   ========================================================================== */

/* Country-code labels for the origin filter (codes come from the live facets). */
export const COUNTRY_NAMES: { [code: string]: string } = {
  gb: 'UK', ae: 'UAE', at: 'Austria', be: 'Belgium', ch: 'Switzerland',
  cn: 'China', de: 'Germany', dk: 'Denmark', es: 'Spain', fr: 'France',
  gr: 'Greece', il: 'Israel', in: 'India', is: 'Iceland', it: 'Italy',
  jp: 'Japan', kr: 'South Korea', kz: 'Kazakhstan', lu: 'Luxembourg',
  mt: 'Malta', nl: 'Netherlands', no: 'Norway', pl: 'Poland', pt: 'Portugal',
  ru: 'Russia', se: 'Sweden', tr: 'Turkey', ua: 'Ukraine', vn: 'Vietnam',
  ie: 'Ireland', us: 'United States', ir: 'Iran',
};

/* The engine's substitution table — DISPLAY COPY of the canonical source
   (plato-lambda .../helpers/perfect_plates.py letter_to_numbers). The engine
   is the source of truth; when the resolve service lands (Task 5) this table
   is served, not shipped. 18 letters have a form; C F J K P V X Y do not. */
export const ALPHABET: { letter: string; forms: string[] }[] = [
  { letter: 'A', forms: ['4'] },   { letter: 'B', forms: ['8'] },
  { letter: 'C', forms: [] },      { letter: 'D', forms: ['0'] },
  { letter: 'E', forms: ['3'] },   { letter: 'F', forms: [] },
  { letter: 'G', forms: ['6', '9'] }, { letter: 'H', forms: ['11'] },
  { letter: 'I', forms: ['1'] },   { letter: 'J', forms: [] },
  { letter: 'K', forms: [] },      { letter: 'L', forms: ['1'] },
  { letter: 'M', forms: ['111'] }, { letter: 'N', forms: ['11'] },
  { letter: 'O', forms: ['0'] },   { letter: 'P', forms: [] },
  { letter: 'Q', forms: ['0'] },   { letter: 'R', forms: ['2', '12'] },
  { letter: 'S', forms: ['5'] },   { letter: 'T', forms: ['7'] },
  { letter: 'U', forms: ['11'] },  { letter: 'V', forms: [] },
  { letter: 'W', forms: ['111'] }, { letter: 'X', forms: [] },
  { letter: 'Y', forms: [] },      { letter: 'Z', forms: ['2'] },
];

/* Hero exemplars — every entry validated against the canonical engine
   (Task 2, 20 Jul 2026). Sophia removed: the engine rejects SOP111A.
   Elliot is the proposed replacement (on the Register, hammer-verified sale). */
export const HERO_SET: { name: string; display: string; subIdx: number[]; note: string }[] = [
  { name: 'James',   display: 'J4 MES',   subIdx: [1],       note: 'One substitution. A 4 standing in for an A.' },
  { name: 'Matilda', display: 'MA71 LDA', subIdx: [2, 3],    note: 'A 7 for the T, a 1 for the I, on a 2021 plate.' },
  { name: 'Alison',  display: 'A11 SON',  subIdx: [1, 2],    note: 'Two separate ones, doing an L and an I.' },
  { name: 'Thomas',  display: 'T110 MAS', subIdx: [1, 2, 3], note: 'Two ones read as an H, right in the middle.' },
  { name: 'Elliot',  display: 'ELL 10T',  subIdx: [4, 5],    note: 'A 1 and a 0 standing in for the I and the O.' },
];
